import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import vuetify from './plugins/vuetify';
import loginStore from '@/util/loginStore';
import { StripePlugin } from '@vue-stripe/vue-stripe';
import i18n, { initializeI18n } from './i18n';

// Set up JWT token before creating Vue instance
const token = loginStore.jwt;
if (token) {
  axios.defaults.headers.common['Authorization'] = token;
}

// Configure Stripe
const stripeOptions = {
  pk: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
};

console.log(`stripeOptions: ${JSON.stringify(stripeOptions)}`);

Vue.use(StripePlugin, stripeOptions);

// Create Vue instance
const vm = new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');

// Initialize localization after Vue instance is mounted
// This ensures $i18n is available if needed during init
initializeI18n()
  .then(() => {
    console.log('Localization loaded successfully');
  })
  .catch(error => {
    console.warn('Using local translations as fallback:', error);
  });
